import { Add, Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import SavedAddress from "components/saved-address";
import { CART_DELV_TYPE } from "constants/general";
import { useEffect, useState } from "react";
import { getAddress } from "slices/addressReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const BookingAddress = ({
  onPickupListingAddress,
  onAddressChange,
  selectedAddress,
}: {
  onPickupListingAddress: any;
  onAddressChange: any;
  selectedAddress: any;
}) => {
  const { addressReducer, cartReducer }: any = useAppSelector((state) => state);
  const { savedAddress } = addressReducer;

  const item = cartReducer?.items?.[0] ?? {};
  const addressObj: any = item?.listings?.listing_address ?? null;
  const dispatch = useAppDispatch();
  const [addNewAddress, setAddNewAddress] = useState(false);

  useEffect(() => {
    dispatch(getAddress());
    if (item?.delivery_type === CART_DELV_TYPE.PICKUP) {
      onPickupListingAddress(addressObj?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.delivery_type]);

  useEffect(() => {
    if (savedAddress.length === 1) {
      onAddressChange(savedAddress[0]?.id);
    } else {
      const defaultAdd = savedAddress.filter((r: any) => r.is_default);
      onAddressChange(defaultAdd[0]?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedAddress]);

  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "10px",
        padding: "2% 3.5%",

        mt: "25px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "64px",
          color: "#323232",
        }}
      >
        Select Address
      </Typography>

      <Box>
        {savedAddress
          .filter((r: any) => r.is_default)
          .map((add: any) => (
            <Box
              sx={{
                borderBottom: "1px solid #E2E2E2",
                py: "15px",
                display: "flex",
                gap: "15px",
              }}
            >
              <Checkbox
                sx={{ padding: "0px" }}
                checkedIcon={
                  <img src="/assets/img/icons/radio_checked.svg" alt="" />
                }
                icon={
                  <img src="/assets/img/icons/radio_unchecked.svg" alt="" />
                }
                onClick={() => onAddressChange(add.id)}
                checked={Number(selectedAddress) === add.id}
              />
              <Typography
                sx={{
                  color: "#323232",
                  fontSize: "15px",
                  fontWeight: 500,
                  lineHeight: "24px",
                }}
              >
                {[
                  add.address_line_1,
                  add.address_line_2,
                  add.city,
                  add.state,
                  add.zipcode,
                ]
                  .filter((r) => r)
                  .join(", ")}
              </Typography>
            </Box>
          ))}

        <Button
          startIcon={<Add />}
          onClick={() => setAddNewAddress(true)}
          sx={{ padding: 0, mt: "15px" }}
        >
          Add New Address
        </Button>
      </Box>

      {addNewAddress && (
        <Dialog
          open
          maxWidth="lg"
          fullWidth
          onClose={() => setAddNewAddress(false)}
          sx={{ padding: 0 }}
        >
          <DialogTitle
            sx={{
              padding: 2,
              display: "flex",
              position: "absolute",
              right: 0,
            }}
          >
            <IconButton onClick={() => setAddNewAddress(false)}>
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: 0 }}>
            <SavedAddress
              onClose={() => setAddNewAddress(false)}
              selectionMode={true}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default BookingAddress;
